<script>
import get from 'lodash/get'
import startCase from 'lodash/startCase'
import ExpandedRow from '@lib/layouts/table/features/expanded-row'

export default {
  name: 'LogList',
  components: {
    ExpandedRow,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    fields() {
      if (!get(this.config, 'fields')) return

      return this.config.fields.map(field => {
        if (typeof field === 'string') field = { name: field }
        const value = this.data.changeSet[field.name]
        field.value = typeof field.template === 'function'
          ? field.template(value, field, this.data)
          : value
        return field
      })
    },
  },
  methods: {
    startCase,
  },
}
</script>

<template>
  <table :class="$style.table">
    <template v-for="(field) in fields">
      <template v-if="field.value !== null && field.value !== undefined">
        <expanded-row
          :key="field.name"
          v-bind="$attrs"
        >
          <div slot="expanded-row-cell-1">
            {{ field.title || startCase(field.name) }}
          </div>

          <div slot="expanded-row-cell-2">
            <template v-if="field.slot">
              <slot
                :name="field.slot"
                :value="field.value"
                :field="field"
              />
            </template>
            <template v-else>
              {{ field.value || '—' }}
            </template>
          </div>
        </expanded-row>
      </template>
    </template>
  </table>
</template>

<style lang="scss" module>
  .table {
    width: 100%;
    border-collapse: collapse;
  }
</style>

